function getURLVar(key) {
  var value = [];

  var query = String(document.location).split("?");

  if (query[1]) {
    var part = query[1].split("&");

    for (i = 0; i < part.length; i++) {
      var data = part[i].split("=");

      if (data[0] && data[1]) {
        value[data[0]] = data[1];
      }
    }

    if (value[key]) {
      return value[key];
    } else {
      return "";
    }
  }
}
var stickyOffset = 0;

function replaceUrlParam(url, paramName, paramValue) {
  let pattern = new RegExp("\\b(" + paramName + "=).*?(&|$)");
  if (url.search(pattern) >= 0) {
    return url.replace(pattern, "$1" + paramValue + "$2");
  }
  return (
    url + (url.indexOf("?") > 0 ? "&" : "?") + paramName + "=" + paramValue
  );
}

function filterCollParam(url, loader = true) {
  const wraperAjax = document.getElementById("wraper_ajax");
  loader && wraperAjax.classList.remove("d-none");
  fetch(url)
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.text();
    })
    .then((responseText) => {
      const parser = new DOMParser();
      const responseDoc = parser.parseFromString(responseText, "text/html");

      if (loader) {
        updateElementContent(
          responseDoc,
          "#custom-products",
          "custom-products"
        );
      } else {
        updateElementContent(
          responseDoc,
          "#custom-products",
          "custom-products",
          true
        ); // for loadmore pagination
      }
      updateElementContent(
        responseDoc,
        "#toolbar-products",
        "toolbar-products"
      );
      updateElementContent(responseDoc, "#column-left", "column-left");
      updateElementContent(responseDoc, "#pagination", "pagination");
      //updateElementContent(responseDoc, "#top_filter_bar", "top_filter_bar");
      //updateElementContent(responseDoc, "#side_filter_bar", "side_filter_bar");
      //updateElementContent(responseDoc, "#active-filters", "active-filters");
      //updateElementContent(responseDoc, "#collection-amount", "collection-amount");

      handleLocalStorageView();

      history.pushState({ page: url }, url, url);

      loader && wraperAjax.classList.add("d-none");

      SPR?.registerCallbacks();
      SPR?.initRatingHandler();
      SPR?.initDomEls();
      SPR?.loadProducts();
      SPR?.loadBadges();

      initSlider();

      // Handle Wishlist
      if (mt.show_wishlist === true) {
        setTimeout(() => {
          Wishlist.init();
        }, 300);
      }

      //filterAttributeHandler();
    })
    .catch((error) => {
      console.error("Fetch error: ", error);
      loader && wraperAjax.classList.add("d-none");
    });
}

function updateElementContent(
  responseDoc,
  sourceSelector,
  targetId,
  isPagination = false
) {
  const source = responseDoc.querySelector(sourceSelector);
  const target = document.getElementById(targetId);
  if (source && source.innerHTML.trim() && target) {
    if (isPagination) {
      target.innerHTML += source.innerHTML;
    } else {
      target.innerHTML = source.innerHTML;
    }
  }
}

function updateInnerHtml(selector, sourceDoc) {
  const targetElement = document.querySelector(selector);
  if (targetElement && sourceDoc.querySelector(selector)) {
    targetElement.innerHTML = sourceDoc.querySelector(selector).innerHTML;
  }
}

function handleLocalStorageView() {
  const typeElement = document.getElementById("category-view-type");
  const colsElement = document.getElementById("category-grid-cols");
  if (typeElement && colsElement) {
    const type = typeElement.value;
    const cols = colsElement.value;

    if (!localStorage.getItem("type")) {
      if (cols) {
        if (type === "list") {
          category_view.initView(type, cols, "btn-list");
          //category_view.customPriceBoxList();
        } else if (type === "grid") {
          category_view.initView(type, cols, "btn-grid-" + cols);
          //category_view.customPriceBoxGrid();
        }
      }
    } else {
      const storedType = localStorage.getItem("type");
      const element = localStorage.getItem("element");
      const storedCols = localStorage.getItem("cols");
      category_view.initView(storedType, storedCols, element);
    }
  }
}

mt.toastMsg = function (msg, type = "success") {
  toastContainer = document.querySelector(".toast-container");
  var div = document.createElement("div");
  var type = "text-bg-" + type;
  div.classList.add("toast", "fade", "align-items-center", "border-0", type);
  div.setAttribute("role", "alert");
  div.setAttribute("aria-live", "assertive");
  div.setAttribute("aria-atomic", "true");
  div.style.backgroundColor = mt.colorSkin;
  div.innerHTML = `<div class="d-flex">
  <div class="toast-body">${msg}</div>
  <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
</div>`;
  toastContainer.appendChild(div);
  var toast = new bootstrap.Toast(div);
  toast.show();
};

function isEmpty(element) {
  return element === null || element === undefined;
}

/* resize code for equal size grids and content start */

if (mt.grid_auto_resize != "false") {
  mt.resizeGrid = function (section, rows) {
    // Equal height grid divs
    const items = document.querySelectorAll(`${section} .row_items`);
    const images = document.querySelectorAll(
      `${section} .row_items .item .item-inner .image img`
    );

    if (items.length > 0 && images.length > 0) {
      const gridwidth = items[0].clientWidth;
      const newHeight = gridwidth / mt.img_ratio;

      images.forEach(function (image) {
        image.style.height = newHeight + "px";
      });
    }

    if (rows > 1) {
      const captions = document.querySelectorAll(
        `${section} .row_items .item .item-inner .caption`
      );
      let gridheight = -1;

      captions.forEach(function (caption) {
        gridheight = Math.max(gridheight, caption.clientHeight);
      });

      captions.forEach(function (caption) {
        caption.style.height = gridheight + "px";
      });
    }
  };
  mt.equalDivs = function () {
    // for equal height grid divs on mobile
    if (window.innerWidth <= 478) {
      var gridheight = -1;

      var captions = document.querySelectorAll(
        ".custom-category .col-xs-6 .item .item-inner .caption"
      );
      captions.forEach(function (caption) {
        gridheight =
          gridheight > caption.offsetHeight ? gridheight : caption.offsetHeight;
      });

      captions.forEach(function (caption) {
        caption.style.height = gridheight - 0 + "px";
      });
    }
    // blog page equal height grid divs
    if (window.innerWidth >= 479) {
      var gridheight = -1;

      var articleGrids = document.querySelectorAll(
        ".blog-blog .article-list.grid"
      );
      articleGrids.forEach(function (articleGrid) {
        gridheight =
          gridheight > articleGrid.offsetHeight
            ? gridheight
            : articleGrid.offsetHeight;
      });

      articleGrids.forEach(function (articleGrid) {
        articleGrid.style.height = gridheight + 10 + "px";
      });
    }
  };
  mt.resizeInsta = function () {
    // Instagram equal height grid divs
    let gridheight;
    const images = document.querySelectorAll(
      "#instagram_block_home1 .owl-carousel img"
    );

    if (images.length > 0) {
      gridheight = images[0].clientWidth;
      images.forEach(function (image) {
        image.style.height = gridheight + "px";
      });
    }
  };
  mt.resizethumbs = function () {
    // product page slideshow thumbs
    const items = document.querySelectorAll(
      ".additional-images.owl-carousel .owl-stage .owl-item"
    );
    const images = document.querySelectorAll(
      ".additional-images.owl-carousel .owl-item img"
    );

    if (items.length > 0 && images.length > 0) {
      const thumbwidth = items[0].clientWidth;
      const newHeight = thumbwidth / mt.img_ratio;

      images.forEach(function (image) {
        image.style.height = newHeight + "px";
      });
    }
  };
  mt.resizeRecentGrid = function () {
    // product page slideshow thumbs
    const items = document.querySelectorAll(
      "#recently-viewed-products.owl-carousel .owl-stage .owl-item"
    );
    const images = document.querySelectorAll(
      "#recently-viewed-products.owl-carousel .owl-item img"
    );

    if (items.length > 0 && images.length > 0) {
      const thumbwidth = items[0].clientWidth;
      const newHeight = thumbwidth / mt.img_ratio;

      images.forEach(function (image) {
        image.style.height = newHeight + "px";
      });
    }
  };
  // resize code for equal size grids and content end
  window.addEventListener("resize", function () {
    setTimeout(function () {
      mt.equalDivs();
      mt.resizeInsta();
      mt.resizeRecentGrid();
    }, 200);
  });
}
mt.countDownTimer = function (cItem, cDate) {
  var countDownDate = new Date(cDate).getTime();
  var countDownItem = cItem + " .countdown-row";
  var x = setInterval(function () {
    var now = new Date().getTime();
    var distance = countDownDate - now;
    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var hours = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((distance % (1000 * 60)) / 1000);
    var countDownItemDetails = document.querySelector(countDownItem);
    if (countDownItemDetails) {
      document.querySelector(
        countDownItem
      ).innerHTML = `<span class="countdown-section">
      <span class="time-info">
        <span class="countdown-amount">${days}</span><span class="countdown-period">Days</span>
      </span>
    </span>
    <span class="countdown-section">
      <span class="time-info">
        <span class="countdown-amount">${hours}</span><span class="countdown-period">Hrs</span>
      </span>
    </span>
    <span class="countdown-section">
      <span class="time-info">
        <span class="countdown-amount">${minutes}</span><span class="countdown-period">Mins</span>
      </span>
    </span>
    <span class="countdown-section">
      <span class="time-info">
        <span class="countdown-amount">${seconds}</span><span class="countdown-period">Secs</span>
      </span>
    </span>`;
    }
    if (distance < 0) {
      clearInterval(x);
      days = hours = minutes = seconds = 0;
    }
  }, 1000);
};
mt.currencyConverter = function () {
  if (mt.show_multiple_currencies == "true") {
    var cookieCurrency = Currency.cookie.read();
    if (cookieCurrency == null) {
      Currency.convertAll(shopCurrency, mt.defaultCurrency);
    } else {
      Currency.convertAll(shopCurrency, cookieCurrency);
    }
  }
};

document.addEventListener("DOMContentLoaded", function () {
  if (mt.grid_auto_resize != "false") {
    mt.equalDivs();
    mt.resizeInsta();
  }

  // sidebar mobile toggle code start
  if (window.innerWidth <= 991) {
    const sidebarToggle = document.querySelector("#sidebar-toggle");
    if (sidebarToggle) {
      const sidebarToggleMenu = sidebarToggle.querySelector(".oc-menu-bar");
      const sidebarToggleMenuEffect =
        sidebarToggle.querySelector(".menu-effect").value;
      const sidebar = document.querySelector("#column-left");
      const sidebarOverlay = document.querySelector(".sidebar-overlay");

      sidebarToggleMenu &&
        sidebarToggleMenu.addEventListener("click", function (e) {
          e.stopPropagation();
          sidebar.classList.add("sidebar-toggle");
          sidebar.style.display = "block";
          sidebarOverlay.style.display = "block";
          if (sidebarToggleMenuEffect == "none") {
            sidebar.classList.add("sidebar-toggle-none");
          }
        });
      sidebarOverlay &&
        sidebarOverlay.addEventListener("click", function (e) {
          e.stopPropagation();
          sidebar.classList.remove("sidebar-toggle");
          sidebar.classList.remove("sidebar-toggle-none");
          sidebar.style.display = "none";
          sidebarOverlay.style.display = "none";
        });
    }
  }
  // sidebar mobile toggle code end

  // Adding active class for mobtabs on mobile layout
  // const mobTabs = document.querySelectorAll('.mobtab');
  // if (mobTabs) {
  //   mobTabs.forEach(function(mobTab) {
  //     mobTab.addEventListener('click', function(e) {
  //       e.preventDefault();
  //       mobTabs.forEach(function(mobTab) {
  //         mobTab.classList.remove('active');
  //       });
  //       this.classList.add('active');
  //     });
  //   });
  // }
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".mobtab a").forEach(function (element) {
    element.addEventListener("click", function (event) {
      // Remove 'active' class from all '.mobtab a' elements
      document.querySelectorAll(".mobtab a").forEach(function (el) {
        el.classList.remove("active");
      });

      // Add 'active' class to the clicked element
      this.classList.add("active");
    });
  });

  document
    .querySelectorAll(".popup-youtube, .popup-vimeo, .popup-gmaps")
    .forEach(function (element) {
      element.addEventListener("click", function (event) {
        event.preventDefault();
        openVideoModal(this.href); // 'this' refers to the anchor tag (element) with the event listener
      });
    });

  function createVideoModal() {
    const modalHtml = `
      <div class="modal fade" id="video-modal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="ratio ratio-16x9">
                <iframe id="video-iframe" class="embed-responsive-item" frameborder="0" allowfullscreen></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;
    document.body.insertAdjacentHTML("beforeend", modalHtml);
  }

  function openVideoModal(videoUrl) {
    if (!document.getElementById("video-modal")) {
      createVideoModal();
    }

    var iframe = document.getElementById("video-iframe");
    var modalElement = document.getElementById("video-modal");
    var modal = new bootstrap.Modal(modalElement);

    // Convert YouTube video URL to embed URL
    var videoUrl = videoUrl.replace("watch?v=", "embed/");

    iframe.src = videoUrl;
    modal.show();

    modalElement.addEventListener("hidden.bs.modal", function () {
      iframe.src = "";
    });
  }

  // !!document.querySelectorAll('.swatch :radio') && document.querySelectorAll('.swatch :radio').forEach(function (element) {
  document
    .querySelectorAll('.swatch input[type="radio"]')
    .forEach(function (element) {
      element.addEventListener("change", function () {
        var optionIndex =
          this.closest(".swatch").getAttribute("data-option-index");
        var optionValue = this.value;

        var singleOptionSelector = this.closest("form").querySelectorAll(
          ".single-option-selector"
        )[optionIndex];
        //var singleOptionSelector = document.querySelectorAll('.single-option-selector[form="' + this.form.id + '"]')[optionIndex];

        if (singleOptionSelector) {
          singleOptionSelector.value = optionValue;
          singleOptionSelector.dispatchEvent(new Event("change"));
        }

        var optionIndexSectionSwatch = this.closest(
          ".swatch .swatch-element"
        ).getAttribute("data-variant");

        var hiddenInput = this.closest("form").querySelector("input[name=id]");
        if (hiddenInput) {
          hiddenInput.value = optionIndexSectionSwatch;
        }
      });
    });

  // product page add to cart
  document
    .getElementById("button-cart")
    ?.addEventListener("click", function (e) {
      e.preventDefault();
      var buttonCart = document.getElementById("button-cart");
      addProductToCart(buttonCart);
    });

  document
    .getElementById("button-cart-sticky")
    ?.addEventListener("click", function (e) {
      e.preventDefault();
      var buttonCartSticky = document.getElementById("button-cart-sticky");
      addProductToCart(buttonCartSticky);
    });

  document
    .getElementById("button-cart-buy")
    ?.addEventListener("click", function (e) {
      e.preventDefault();
      var buttonCartBuy = document.getElementById("button-cart-buy");
      addProductToCart(buttonCartBuy, (redirect = "checkout"));
    });

  function addProductToCart(buttonCart, formData) {
    buttonCart.disabled = true;
    buttonCart.innerHTML += `<i class="fa fa-spinner fa-spin d-inline-block ms-2"></i>`;

    // Serialize form data
    var form = document.getElementById("form_buy");
    var formData = new FormData(form);

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "post",
      body: formData,
    })
      .then((response) => {
        if (!response.ok) {
          throw {
            status: response.status,
            statusText: response.statusText,
            description: "Failed to add to cart",
          };
        }
        return response.json();
      })
      .then((json) => {
        return fetch(window.Shopify.routes.root + "cart.js");
      })
      .then((response) => {
        if (!response.ok) {
          throw {
            status: response.status,
            statusText: response.statusText,
            description: "Failed to fetch cart",
          };
        }
        return response.json();
      })
      .then((cartResponse) => {
        load(cartResponse);
        if (mt.add_to_cart_layout === "message") {
          mt.toastMsg(mt.product.item_added, "success");
          window.scrollTo({ top: 0, behavior: "smooth" });
        } else if (mt.add_to_cart_layout === "redirect") {
          window.top.location.href = "/checkout";
        } else if (redirect === "checkout") {
          window.top.location.href = "/checkout";
        }
      })
      .catch((error) => {
        displayErrorMessage(error); // Implement this function to display error messages to the user
      })
      .finally(() => {
        buttonCart.disabled = false;
        buttonCart.querySelector(".fa-spinner")?.remove();
      });
  }

  function displayErrorMessage(error) {
    let message = "An error occurred. Please try again.";
    if (error.status === 422) {
      mt.toastMsg(mt.product.item_added_402, "warning");
    } else {
      message = error.status + "\r\n" + error.description;
      alert(message);
    }
  }

  // content collapse blocks
  const collapseHeaders = document.querySelectorAll(".product-collapse-header");

  collapseHeaders.forEach((header) => {
    header.addEventListener("click", function () {
      const indicator = this.querySelector(".collapse-indicator");
      if (indicator.innerText === "+") {
        indicator.innerText = "-";
      } else {
        indicator.innerText = "+";
      }
    });
  });

  const header = document.querySelector("header");
  const stickyTrigger = header?.querySelector(".fix");

  if (stickyTrigger) {
    // Create a spacer for the header
    const headerSpace = document.createElement("div");
    if (header && headerSpace) {
      headerSpace.classList.add("headerSpace", "unvisible");
      headerSpace.style.height = `${header.offsetHeight}px`;
      header.parentNode.insertBefore(headerSpace, header);
    }

    // Function to update header space and class based on intersection and window width
    const updateHeader = (isIntersecting) => {
      if (window.innerWidth >= 991) {
        if (!isIntersecting) {
          document.querySelector(".fix").classList.add("fix-header");
          headerSpace.classList.remove("unvisible");
          headerSpace.classList.add("d-block");
        } else {
          document.querySelector(".fix").classList.remove("fix-header");
          headerSpace.classList.add("unvisible");
          headerSpace.classList.remove("d-block");
        }
        //headerSpace.style.height = `${header.offsetHeight}px`; // Update header space height
      }
    };

    // Observer for the Header
    const headerObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          updateHeader(entry.isIntersecting);
        });
      },
      { threshold: [0] }
    );
    headerObserver.observe(header);

    // Handle browser resize
    window.addEventListener("resize", () => {
      updateHeader(
        !headerObserver.takeRecords().some((entry) => entry.isIntersecting)
      );
    });
  }

  // const header = document.querySelector("header");
  // // if header contain class fix then add class fix-header to headerSpace
  // const stickyTrigger = header?.querySelector(".fix");

  // if (stickyTrigger) {
  //   // Create a spacer for the header
  //   const headerSpace = document.createElement("div");
  //   if (header && headerSpace) {
  //     headerSpace.classList.add("headerSpace", "unvisible");
  //     headerSpace.style.height = `${header.offsetHeight}px`;
  //     header.parentNode.insertBefore(headerSpace, header);
  //   }
  //   //headerSpace.style.height = `${header.offsetHeight}px`;

  //   // Observer for the Header
  //   const headerObserver = new IntersectionObserver(
  //     (entries) => {
  //       entries.forEach((entry) => {
  //         if (window.innerWidth >= 991) {
  //           if (!entry.isIntersecting) {
  //             document.querySelector(".fix").classList.add("fix-header");
  //             headerSpace.classList.remove("unvisible");
  //             headerSpace.classList.add("show");
  //           } else {
  //             document.querySelector(".fix").classList.remove("fix-header");
  //             headerSpace.classList.add("unvisible");
  //             headerSpace.classList.remove("show");
  //           }
  //         }
  //       });
  //     },
  //     { threshold: [0] }
  //   );
  //   headerObserver.observe(header);
  // }

  // Observer for the Product Page Sticky Cart Footer
  const productProductEl = document.querySelector("#product-product");

  if (productProductEl) {
    const formBuy = document.querySelector("#product-product");
    if (stickyTrigger) {
      const formBuyObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) {
              const formBuySticky = document.querySelector(".form_buy_sticky");
              if (formBuySticky) {
                formBuySticky.classList.add("fix-header2", "fix-header1");
                const formBuyStickyHeight = formBuySticky.offsetHeight;
                document.documentElement.style.paddingBottom = `${formBuyStickyHeight}px`;
              }
            } else {
              document
                .querySelector(".form_buy_sticky")
                ?.classList.remove("fix-header1", "fix-header2");
              document.documentElement.style.paddingBottom = "0px";
            }
          });
        },
        { threshold: [0] }
      );

      formBuyObserver.observe(formBuy);
    }
  }

  const textDangers = document.querySelectorAll(".text-danger");

  textDangers.forEach(function (textDanger) {
    const element = textDanger.parentElement.parentElement;

    if (element.classList.contains("form-group")) {
      element.classList.add("has-error");
    }
  });

  /* Search */
  const searchInput = document.querySelector('#search input[name="q"]');
  const searchButton = searchInput?.parentElement.querySelector("button");

  searchButton?.addEventListener("click", function () {
    let url = window.Shopify.routes.root + "search";
    //var url = '/search';
    let type = document.querySelector('#search input[name="type"]')
      ? document.querySelector('#search input[name="type"]').value
      : null;
    let value;

    if (type === "blog") {
      value = document.querySelector('#search.blog input[name="q"]').value;
    } else {
      value = document.querySelector('header #search input[name="q"]').value;
      type = "product";
    }

    if (value === "Search all products..." || value === "") {
      searchInput.focus();
      return false;
    } else {
      url += "?type=" + type + "&q=" + encodeURIComponent(value);
    }
    console.log(url);
    window.location = url;
  });

  searchInput?.addEventListener("keydown", function (e) {
    if (e.keyCode === 13) {
      let searchType = document.querySelector('#search input[name="type"]')
        ? document.querySelector('#search input[name="type"]').value
        : null;
      if (searchType === "blog") {
        searchButton.click();
      } else {
        document
          .querySelector('header #search input[name="q"]')
          .parentElement.querySelector("button")
          .click();
      }
    }
  });

  // Menu
  const menuDropdowns = document.querySelectorAll("#menu .dropdown-menu");

  menuDropdowns.forEach(function (dropdownMenu) {
    const menu = document.getElementById("menu").getBoundingClientRect();
    const dropdownParent = dropdownMenu.parentElement.getBoundingClientRect();

    const i =
      dropdownParent.left + dropdownMenu.offsetWidth - (menu.left + menu.width);

    if (i > 0) {
      dropdownMenu.style.marginInlineStart = `-${i + 10}px`;
    }
  });

  // Product List
  document.getElementById("list-view") &&
    document.getElementById("list-view").addEventListener("click", function () {
      const clearfixElements = document.querySelectorAll(
        "#content .product-grid > .clearfix"
      );
      clearfixElements.forEach((clearfix) =>
        clearfix.parentNode.removeChild(clearfix)
      );

      document
        .querySelector("#content .row > .product-grid")
        .setAttribute(
          "class",
          "product-layout product-list col-xs-12 product-item"
        );
      document.getElementById("grid-view").classList.remove("active");
      document.getElementById("list-view").classList.add("active");

      const productItems = document.querySelectorAll(".product-item .item");
      productItems.forEach(function (item) {
        const caption = item.querySelector(".caption");
        const actionLinks = item.querySelector(".action-links");
        caption.appendChild(actionLinks);
      });

      localStorage.setItem("display", "list");
      localStorage.setItem("type", "none");
    });

  // Product Grid
  document.getElementById("grid-view") &&
    document.getElementById("grid-view").addEventListener("click", function () {
      const cols = document.querySelectorAll(
        "#column-right, #column-left"
      ).length;
      const productLayoutClass =
        cols === 2
          ? "col-lg-6 col-md-6 col-sm-6 col-xs-6"
          : cols === 1
          ? "col-lg-4 col-md-4 col-sm-6 col-xs-6"
          : "col-lg-3 col-md-3 col-sm-6 col-xs-6";

      const productList = document.querySelector("#content .product-list");
      productList.setAttribute(
        "class",
        `product-layout product-grid grid-style ${productLayoutClass} product-item`
      );

      document.getElementById("list-view").classList.remove("active");
      document.getElementById("grid-view").classList.add("active");

      const productItems = document.querySelectorAll(".product-item .item");
      productItems.forEach(function (item) {
        const imagesContainer = item.querySelector(".images-container");
        const actionLinks = item.querySelector(".action-links");
        imagesContainer.appendChild(actionLinks);
      });

      localStorage.setItem("display", "grid");
      localStorage.setItem("type", "none");
    });

  if (
    localStorage.getItem("display") === "list" &&
    document.getElementById("list-view")
  ) {
    document.getElementById("list-view").click();
    document.getElementById("list-view").classList.add("active");
  } else if (
    localStorage.getItem("display") === "grid" &&
    document.getElementById("grid-view")
  ) {
    document.getElementById("grid-view").click();
    document.getElementById("grid-view").classList.add("active");
  }

  // grid-style
  const gridStyleItems = document.querySelectorAll(".grid-style .item");

  gridStyleItems?.forEach((item) => {
    item.addEventListener("mouseover", function () {
      const closestGridStyle = item.closest(".grid-style");
      if (closestGridStyle) {
        closestGridStyle.classList.add("active");
      }
    });

    item.addEventListener("mouseout", function () {
      const closestGridStyle = item.closest(".grid-style");
      if (closestGridStyle) {
        closestGridStyle.classList.remove("active");
      }
    });
  });

  // tooltips on hover
  // $('[data-bs-toggle=\'tooltip\']').tooltip({container: 'body'});
  const tooltipElements = document.querySelectorAll(
    '[data-bs-toggle="tooltip"]'
  );
  tooltipElements.forEach(function (element) {
    const tooltip = new bootstrap.Tooltip(element, { container: "body" });
  });
});

var cart = {
  add: function (product_id, quantity, redirect) {
    const data = new FormData();
    data.append("id", product_id);
    data.append("quantity", typeof quantity !== "undefined" ? quantity : 1);

    var button = event.target;
    button.innerHTML += `<i class="fa fa-spinner fa-spin d-inline-block ms-2"></i>`;

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "post",
      body: data,
    })
      .then((response) => {
        if (!response.ok) {
          throw response;
        }
        return response.json();
      })
      .then((json) => {
        button.querySelector("i.fa-spinner").remove();

        if (json["redirect"]) {
          location = json["redirect"];
        }

        fetch(window.Shopify.routes.root + "cart.js")
          .then((response) => response.json())
          .then((cartResponse) => {
            if (redirect) {
              window.top.location.href = "/checkout";
            }
            if (mt.add_to_cart_layout === "message") {
              mt.toastMsg(mt.product.item_added, "success");
              load(cartResponse);
            } else if (mt.add_to_cart_layout === "redirect") {
              window.top.location.href = window.Shopify.routes.root + "/checkout";
            }
          });
      })
      .catch((error) => {
        console.log(error);
        if (error.status === 422) {
          mt.toastMsg(mt.product.item_added_402, "warning");
        } else {
          error.text().then((responseText) => {
            alert(error.statusText + "\r\n" + responseText);
          });
        }
      });
  },
  remove: function (key) {
    const data = new URLSearchParams();
    data.append(`updates[${key}]`, 0);

    fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "post",
      body: data,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw response;
        }
        return response.json();
      })
      .then((json) => {
        if (
          window.location.pathname === "/cart" ||
          window.location.pathname === "/checkout"
        ) {
          location = window.Shopify.routes.root + "/cart";
        } else {
          setTimeout(function () {
            load(json);
          }, 5);
        }
      })
      .catch((error) => {
        alert(error.responseText);
      });
  },
};

function load(cart) {
  const cartDropdown = document.querySelector(
    "#cart .dropdown-menu > li:first-child .table > tbody"
  );
  cartDropdown.innerHTML = "";

  cart.items.forEach(function (cartItem, index) {
    const line = index + 1;
    let cents = "";

    if (cartItem.price % 100 < 10) {
      cents = "0";
    }
    const price =
      parseInt(cartItem.price / 100) + "." + cents + (cartItem.price % 100);

    const cartRemove = `onclick="cart.remove('${cartItem.id}')"`;
    const cartItemHTML = `<tr><td class='text-center'><a href='${
      cartItem.url
    }' title='${cartItem.title}'><img class='cart-image' src='${
      cartItem.image
    }' alt='${cartItem.title}' title='${
      cartItem.title
    }' loading='lazy' width='auto' height='auto'></a></td><td class='text-left info-item'><a class='cart-name' href='${
      cartItem.url
    }'>${cartItem.title}</a><p class='cart-quantity'>${
      cartItem.quantity
    } &times;</p><p class='cart-price'><span class='money'>${Shopify.formatMoney(
      price,
      moneyFormat
    )}</span></p></td><td class='text-center cart-close'><button type='button' ${cartRemove} title='Remove' class='btn btn-danger btn-xs'><i class='ion-android-close'></i></button></td></tr>`;
    cartDropdown.insertAdjacentHTML("beforeend", cartItemHTML);
  });

  const cartDropdownLastChild = document.querySelector(
    "#cart .dropdown-menu li:not(:first-child):last-child"
  );
  if (cart.item_count < 1) {
    cartDropdown.insertAdjacentHTML(
      "beforeend",
      `<p class="text-center cart-empty">${mt.product.no_items}</p>`
    );
    cartDropdownLastChild.classList.remove("show");
    cartDropdownLastChild.classList.add("hide");
  } else {
    const cartEmpty = document.querySelector(
      "#cart .dropdown-menu p.cart-empty"
    );
    if (cartEmpty) {
      cartEmpty.remove();
    }
    cartDropdownLastChild.classList.remove("hide");
    cartDropdownLastChild.classList.add("show");
  }

  document.querySelector("#cart > button #cart-total .txt_number").innerHTML =
    cart.item_count;
  document.querySelector(
    "#cart > button .total-price"
  ).innerHTML = `<span class=money>${Shopify.formatMoney(
    cart.total_price,
    moneyFormat
  )}<i class="fas fa-chevron-down"></i></span>`;
  document.querySelector(
    "#cart-subtotal"
  ).innerHTML = `<span class=money>${Shopify.formatMoney(
    cart.total_price,
    moneyFormat
  )}</span>`;

  if (mt.show_multiple_currencies == "true") {
    if (Currency.cookie.read() != null) {
      Currency.convertAll(shopCurrency, Currency.cookie.read());
    }
  }
}

/*============================================================================
  API Functions
  - Shopify.format money is defined in option_selection.js.
    If that file is not included, it is redefined here.
==============================================================================*/
// Ensure the Shopify object exists
document.addEventListener("DOMContentLoaded", function () {
  window.Shopify = window.Shopify || {};

  // If Shopify.formatMoney doesn't exist, define it
  if (!Shopify.formatMoney) {
    Shopify.formatMoney = function (cents, format) {
      var value = "",
        placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = format || this.money_format;

      if (typeof cents == "string") {
        cents = cents.replace(".", "");
      }

      function defaultOption(opt, def) {
        return typeof opt == "undefined" ? def : opt;
      }

      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ",");
        decimal = defaultOption(decimal, ".");

        if (isNaN(number) || number == null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split("."),
          dollars = parts[0].replace(
            /(\d)(?=(\d\d\d)+(?!\d))/g,
            "$1" + thousands
          ),
          cents = parts[1] ? decimal + parts[1] : "";

        return dollars + cents;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case "amount":
          value = formatWithDelimiters(cents, 2);
          break;
        case "amount_no_decimals":
          value = formatWithDelimiters(cents, 0);
          break;
        case "amount_with_comma_separator":
          value = formatWithDelimiters(cents, 2, ".", ",");
          break;
        case "amount_no_decimals_with_comma_separator":
          value = formatWithDelimiters(cents, 0, ".", ",");
          break;
      }

      return formatString.replace(placeholderRegex, value);
    };
  }
});
